import { p as proxyCustomElement, H, c as createEvent, h, d as Host } from './p-bfa0dc67.js';
import { c as classNames } from './p-df8c8ec2.js';
import { d as defineCustomElement$2 } from './p-5475c333.js';

const biDialogCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}.dialog{position:fixed;display:flex;border:none;z-index:1300;height:100vh;width:100vw;justify-content:center;align-items:center}.content{z-index:1301;border-radius:8px;box-shadow:0 4px 4px 0 rgba(0, 0, 0, 0.25);width:100%;max-width:500px}.content.content-paddding{padding:16px}.content.background-blue-strong{background-color:#002341;color:white}.content.background-white{background-color:white}";
const BiDialogStyle0 = biDialogCss;

const BiDialog$1 = /*@__PURE__*/ proxyCustomElement(class BiDialog extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.close = createEvent(this, "close", 7);
        /**
         * If true, clicking on the backdrop will not close the dialog.
         */
        this.disableBackdropClick = false;
        /** If true, the dialog is open. */
        this.isOpen = false;
        /**
         * The background color of the dialog. Can be 'white' or 'blue-strong'.
         */
        this.backgroundColor = 'white';
        /** By default, a padding is applied to the content. This option removes that padding. */
        this.removePadding = false;
    }
    render() {
        return (h(Host, { key: 'c77c011be743892951fdf1d1cece0756e4a43cb1' }, h("base-modal", { key: '0392b779a2529ac3f367d5a2402b99b52b28e3b6', classes: 'dialog', disableBackdropClick: this.disableBackdropClick, isOpen: this.isOpen }, h("div", { key: '75be99e4e82eea2a93861b7e59d38e0a30bf3bef', class: classNames('content', `background-${this.backgroundColor}`, {
                'content-paddding': !this.removePadding,
            }) }, h("slot", { key: 'dc7b47529fc782d925bbd10fe49fb2cc478c9212' })))));
    }
    static get style() { return BiDialogStyle0; }
}, [1, "bi-dialog", {
        "disableBackdropClick": [516, "disable-backdrop-click"],
        "isOpen": [516, "is-open"],
        "backgroundColor": [1, "background-color"],
        "removePadding": [4, "remove-padding"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-dialog", "base-modal"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-dialog":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiDialog$1);
            }
            break;
        case "base-modal":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const BiDialog = BiDialog$1;
const defineCustomElement = defineCustomElement$1;

export { BiDialog, defineCustomElement };
